// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Billtrust: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 43"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><g fill="none" fillRule="evenodd"><path fill="#A6A6A6" d="M25.605 42.453H.733L9.743 31.8h21.102c3.43 0 7.946-5.575 9.155-9.696 0 11.248-4.057 20.348-14.395 20.348"/><path fill="#707070" d="M40 22.105V.866l-9.155 10.82V31.8c3.46 0 7.946-5.575 9.155-9.696"/><path fill="#8B8B8B" d="M14.395 0h24.872l-9.005 10.656H9.155c-3.43 0-7.946 5.575-9.155 9.696C0 9.104 4.057 0 14.395 0"/><path fill="#4A4A4A" d="M0 20.352V41.59l9.155-10.82V10.657c-3.447 0-7.946 5.579-9.155 9.696"/></g></svg>;
};

export default React.memo(Billtrust);

